import axios from 'axios';
import { config } from '../config';
import { handleAxiosError } from '../helpers/axios';
import { CreateAccountRegistrationRequest } from '../models/create-account-registration-request';

export const createAccountRegistration =
  () => (request: CreateAccountRegistrationRequest) =>
    axios
      .post(`${config.apiUrl}/account-registrations`, request)
      .catch(handleAxiosError);
